export default __webpack_public_path__ + "static/038e6d8b-b760-44f0-91b3-f45840e8a8ab-68ac074ab854861b93f3d50fe5f83d47.ttf";